import { Box, StepLabel, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import StepIconComponent from './StepIconComponent'
import OptionalTooltipWrapper from '../../Tooltip/OptionalTooltipWrapper'
import { ButtonType, WizardStepModel } from '../types'
import { makeStyles } from 'tss-react/mui'

interface StyleProps {
  isSelectable: boolean
  isActive: boolean
}

interface Props {
  step: WizardStepModel
  stepIndex: number
  onClick: (stepIndex: number) => void
  isActive: boolean
  type: ButtonType
  isSelectable: boolean
}

const useStyles = makeStyles<StyleProps>()((_, { isSelectable, isActive }) => ({
  wrapper: {
    cursor: isSelectable || isActive ? 'pointer' : 'not-allowed',

    '> span': {
      padding: 0,
    },
  },
  container: {
    pointerEvents: isSelectable ? 'auto' : 'none',
  },
}))

/**
 * Displays the stepper of a wizard which allows to move between the steps
 */
const WizardStepContent: React.VFC<Props> = ({ step, stepIndex, isActive, type, onClick, isSelectable }) => {
  const { label, stepNumber, buttonIcon } = step
  const { classes } = useStyles({ isSelectable, isActive })
  const hasTooltip = type === 'invalid' && !isActive
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <OptionalTooltipWrapper hasTooltip={hasTooltip} titleKey={step.validationTooltipTitle}>
      <StepLabel
        className={classes.wrapper}
        onClick={() => (isMobile ? undefined : onClick(stepIndex))}
        StepIconComponent={() => (
          <Box className={classes.container}>
            <StepIconComponent label={label} isActive={isActive} stepNumber={stepNumber} type={type} IconComponent={buttonIcon} isMobile={isMobile} />
          </Box>
        )}
      />
    </OptionalTooltipWrapper>
  )
}

export default WizardStepContent
